import { PrimaryRoleRepeaterWidget } from '../primary-role-repeater-widget/primary-role-repeater-widget';
import editForm from './co-signer-entity.form';
import { CustomComponentType, CustomBuilderGroups, LoanRoleType } from '../../../enums';

export default class CoSignerEntityWidget extends PrimaryRoleRepeaterWidget {
	static schema(...extend: any) {
		return PrimaryRoleRepeaterWidget.schema(
			{
				label: 'Co-Signer',
				type: CustomComponentType.coSignerEntity,
				key: CustomComponentType.coSignerEntity,
				addAnother: 'Add a Co-Signer'
			},
			...extend
		);
	}

	static editForm = editForm;

	static get builderInfo() {
		return {
			title: 'Co-Signer',
			group: CustomBuilderGroups.widgets,
			weight: 10,
			schema: CoSignerEntityWidget.schema({
				skipRemoveConfirm: true
			})
		};
	}

	init() {
		this.roleType = LoanRoleType.CoSigner;

		super.init();
	}
}
